/* eslint-disable */
import { Component } from 'react';
import { DefaultFooter, DefaultHeader, ErrorBoundary, CookieConsentWrap } from 'Components'
import { 
  API, Http,
  Auth, Constant, Utils, _ } from 'Helpers'
import { Redirect, Route, Switch } from "react-router-dom";
import { ReduxHOC } from 'HOC';
// routes config
import Routes from "Routes"
import { SelectLeague } from "Components"
import LoginFormSMWraped from 'Components/LoginFormSM/LoginFormSM';
import { CategoryPage, GuidesLayout, TopicPage } from 'Learn';
import DefaultMobileFooter from 'Components/DefaultMobileFooter';
import { SessionStorage } from 'Helpers/Utilieties';

const FOOTER_STATIC_PATHS = [
  '/how-to-play',
  '/faq',
  '/rules-and-scoring',
  '/privacy-policy',
  '/terms',
  '/support'
];

export const shouldRedirectWithoutLeague = (hasSelectedLeague, name, pathname) => {
  return !hasSelectedLeague &&
    name !== 'ActivateAccount' &&
    name !== 'Learn' &&
    !FOOTER_STATIC_PATHS.includes(pathname);
};

class RenderRoute extends Component {

  removeComponent = () => {
    return _.omit(this.props, ['component'])
  }
  handelNativeData() {
    window.addEventListener("message", (e) => {
     if (e.data == null) {
       return;
     }
      if(e.data.action == 'CLEAR_SPOTLIGHT'){
      SessionStorage.set('spotlight_str', ''); 
      window.location.reload();
     }
    
   });
}
  componentDidMount() {
    const { theme, nodes } = this.props;
    this.handelNativeData();
    if (theme) document.documentElement.setAttribute("class", theme);
    setTimeout(() => {
      // nodes.DefaultHeader.setProps(this.removeComponent())
      // nodes.DefaultFooter.setProps(this.removeComponent())
    }, 0)
    
    if (shouldRedirectWithoutLeague(
      Boolean(Utils.getMultiLeg()),
      this.props.name,
      this.props.location.pathname
    )) {
      this.props.history.push(Constant.DASHBOARD_PATH)
    }
  }
  componentWillUnmount() {
    document.documentElement.removeAttribute("class");
    this.setState = () => {
      return;
    };
  };

  render() {
    const { isPublic, isCommon, isAuthenticate } = this.props
    if( (isAuthenticate && Auth.getAuth()) || (isPublic && !Auth.getAuth()) || (isCommon) ) {
      return (<this.props.component {...this.removeComponent()} />)  
    }
    return (<Redirect from="*" to={Auth.getAuth() ? Constant.DASHBOARD_PATH : Constant.DEFAULT_ROOT} />)
  }
}

class Layout extends Component {
  constructor(props) {
    super(props)
    this.nodes = {}
    this.state = {
      posting: true,
      LanguageSwitchModalShow: window.ReactNativeWebView ? false : Utils.getCookie('lang') === '',
    }
  }

  setDocumentLanguageAttributes = () => {
    const { i18n } = this.props;
    const domLang = i18n.language === 'mal' ? 'fr' : i18n.language;
    document.documentElement.setAttribute("lang", domLang);
    document.documentElement.setAttribute("dir", i18n.language === 'ar' ? 'rtl' : 'ltr');
  }

  // Get App Master Data
  GetAppMasterData = () => {
    // if (!Utils.getMasterData()) {
      Http.post(API.GET_APP_MASTER_DATA).then(res => {
        const { actions } = this.props;

        Utils.setMasterData(res.data)
        const cookieLang = Utils.getCookie('lang');
        const storedLang = Utils.getLang();

        // Keep both stores aligned, but never override an existing user choice.
        if (cookieLang && !storedLang) {
          Utils.setLang(cookieLang)
        } else if (!cookieLang && storedLang) {
          Utils.setCookie('lang', storedLang, 365)
        } else if (!cookieLang && !storedLang) {
          Utils.setLang(res.data.default_language)
          Utils.setCookie('lang', res.data.default_language, 365)
        }

        actions.setAppMaster(res.data) // Redux Data Update
        if(res.data.IS_MULTILEAGUE == 1) {
          this.setState({posting: false})
        }
        setTimeout(() => {
          if (Utils.getMultiLeg()) {
            this.setState({posting: false})
          }
        }, 10)
      }).catch(err => {
        console.log(err);
      })
    // } else {
    //   if (Utils.getMultiLeg()) {
    //     this.setState({posting: false})
    //   }
    // }
  }

  componentDidMount() {
      this.GetAppMasterData()

    this.setDocumentLanguageAttributes();

    // Redux Data Update
    const { actions } = this.props
    actions.setAppMaster(Utils.getMasterData() || {})
    actions.setAdData(Utils.GetSessionStorage('banner') || {})
    if(Auth.getAuth()) {
      this.GetNewBanner()
      actions.setProfileData(Utils.getProfile() || {})
      actions.setCurrentLineup(Utils.getCurrentLineup())
    } else{
      this.GetNewBanner()
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.i18n.language !== this.props.i18n.language) {
      this.setDocumentLanguageAttributes();
    }
  }


  LanguageSwitchToggle = () => {
    this.setState({
      LanguageSwitchModalShow: !this.state.LanguageSwitchModalShow
    }, () => {
      window.location.reload(false);
    })
  }
  
  setNodeRef(provider, node) {
    if (node) {
      this.nodes[provider] = node
    }
  }

  SelectLeagueCallback = (res) => {
   
    if (this.state.posting && res) {
      this.setState({posting: false}, () => {
        //window.location.reload(false);
      })
    }
  }

  // GetAdvBanner = () => {
  //   const SelectedLeague = Utils.getMultiLeg()
  //   if (!SelectedLeague) return;
  //   const { league_id, sports_id} = SelectedLeague
  //   if(!SelectedLeague) return
  //   let s3_param = [
  //     API.S3_GET_BANNER,
  //     league_id
  //   ]
  //   let param = {
  //     league_id: league_id,
  //     sports_id: sports_id
  //   }
  //   // Http.post(API.GET_BANNER, param).then(res => {
  //   Http.s3(Utils.s3UrlConvert(s3_param), API.GET_BANNER, param).then(res => {
  //     let AdData = []
  //     for (let ad of res.data.advertisements) {
  //       for (let pos of res.data.positions) {
  //         if (ad.ad_position_id == pos.ad_position_id) {
  //           AdData.push({ ...pos, ...ad })
  //         }
  //       }
  //     }
  //     Utils.SetSessionStorage('banner', AdData);
  //     // Redux Data Update
  //     const { actions } = this.props;
  //     actions.setAdData(AdData || {})
  //   }).catch(err => {
  //     console.error(err);
  //   })
  // }

  GetNewBanner = () => {
    let s3_param = [
      API.S3_NEW_BANNER
    ]
    let param = {
     league_id: 0,
      contest_id: 0,
      banner_type:'lobby'
    }
   
    Http.s3(Utils.s3UrlConvert(s3_param,true), API.NEW_BANNER, param ).then(res => {
      let AdData = res.data.result;
      
      Utils.SetSessionStorage('banner', AdData);
      const { actions } = this.props;
      actions.setAdData(AdData || {})
    }).catch(err => {
      console.error(err);
    })
  }

  render() {
    const { 
      posting
      // , LanguageSwitchModalShow
    } = this.state
    // const LanguageSwitchModalProps = {
    //   isOpen: LanguageSwitchModalShow,
    //   toggle: this.LanguageSwitchToggle
    // }


    if (posting) return (
      <>
        <Utils.Spinner />
        {
          !Utils.getMultiLeg() &&
          <SelectLeague callback={this.SelectLeagueCallback} is_root/>
        }
      </>
    )
    return (
      <>
        <div className='app-container'>
        <ErrorBoundary>
          <DefaultHeader getInstance={this.setNodeRef.bind(this, 'DefaultHeader')} />
          <main className='main'>
            <Switch>
              {
                Routes.map((route, idx) => {
                  return route.component ?
                    <Route key={idx} path={route.path} exact={route.exact} name={route.name} render={
                      props => <RenderRoute
                        nodes={this.nodes}
                        isPublic={route.isPublic || false}
                        isAuthenticate={route.isAuthenticate || false}
                        isCommon={route.isCommon || false}
                        name={route.name || ''}
                        page_id={route.page_id || ''}
                        meta={route.meta || {}}

                        headerHide={route.headerHide || false}
                        footerHideSm={route.footerHideSm || false}
                        footerHide={route.footerHide || false}

                        component={route.component}
                        {...route.screen}
                        {...props} />
                    } />
                    :
                    null;
                })
              }

              <GuidesLayout>
                <Switch>
                  <Route exact path="/docs/guides/:category" component={CategoryPage} />
                  <Route exact path="/docs/guides/:category/:topic" component={TopicPage} />
                  <Redirect to="/docs/guides/get-started" />
                </Switch>
              </GuidesLayout>
              <Redirect from="*" to={Auth.getAuth() ? Constant.DEFAULT_ROOT : Constant.DEFAULT_ROOT} />
            </Switch>
          </main>
          <DefaultMobileFooter/>
          <DefaultFooter getInstance={this.setNodeRef.bind(this, 'DefaultFooter')} />
          {/* <CookieConsentWrap /> */}
        </ErrorBoundary>
        </div>
        <Utils.NavigationPromptWrap />
      </>
    );
  }
}

export default ReduxHOC(Layout);
